import { useMemo } from 'react'

import { useMetaModelContext } from '../context/metaModelContext'
import { useNavigationParams } from '../system/useNavigationParams'
import { getApplicationViewRegisteredTenants } from './helpers'
import { useOperationsContext } from './operationsContext'

export const useApplicationViewRegisteredTenants = () => {
  const { block } = useNavigationParams()
  const { registeredTenantCreateOperations } = useOperationsContext()
  const { blockTopology } = useMetaModelContext()

  return useMemo(
    () =>
      getApplicationViewRegisteredTenants({
        block,
        blockTopology,
        registeredTenantCreateOperations,
      }),
    [registeredTenantCreateOperations, block, blockTopology],
  )
}
